import React from 'react';
import { Link } from 'react-router-dom';
import blogData from '../../data/blogs.json';

export default function IndexSectionBlogDarkPattern20() {
    // Get the first 2 blog posts
    const featuredBlogs = blogData.blogs.slice(0, 2);

    return (
        <React.Fragment>
            <>
                <section className="pt-16 md:pt-24 bg-coolGray-900 " style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-dark2.svg")', backgroundRepeat: 'no-repeat', backgroundPosition: 'center top'}}>
                    <div className="container px-4 mx-auto">
                        <div className="flex flex-wrap items-center mb-16">
                            <div className="w-full md:w-3/4 mb-8 md:mb-0">
                                <span className="inline-block py-px px-2 mb-4 text-xl leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Blog</span>
                                <h3 className="mb-4 text-4xl md:text-5xl leading-tight text-white font-bold tracking-tighter">Latest Insights</h3>
                                <p className="text-lg md:text-xl text-coolGray-400 font-medium">Discover expert tips, industry trends, and professional insights from our 45 years of experience in tool storage solutions.</p>
                            </div>
                            <div className="w-full md:w-1/4">
                                <Link className="flex items-center justify-center py-2 px-4 ml-auto text-sm leading-5 text-green-50 font-medium bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 md:max-w-max rounded-md transition duration-200" to="/blog">
                                    View All Posts
                                </Link>
                            </div>
                        </div>
                        <div className="flex flex-wrap">
                            {/* Blog Card 1 */}
                            <div className="w-full md:w-1/2 px-4 mb-8 flex">
                                <div className="border border-coolGray-800 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-coolGray-800 flex flex-col h-full">
                                    <Link className="block overflow-hidden" to={`/blog/${featuredBlogs[0].id}`}>
                                        <div className="bg-coolGray-700 p-4">
                                            <img className="w-full object-cover rounded-md" src={featuredBlogs[0].image} alt={featuredBlogs[0].title} />
                                        </div>
                                    </Link>
                                    <div className="p-4 flex-1 flex flex-col">
                                        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-400 hover:text-green-300 font-medium uppercase bg-green-900 bg-opacity-20 hover:bg-opacity-30 rounded-full shadow-sm">
                                                {featuredBlogs[0].category}
                                            </span>
                                        </div>
                                        <Link className="mb-2 text-lg md:text-xl leading-tight text-white hover:text-green-400 font-bold hover:underline" to={`/blog/${featuredBlogs[0].id}`}>
                                            {featuredBlogs[0].title}
                                        </Link>
                                        <p className="text-coolGray-300 mb-4 text-sm md:text-base font-medium flex-1">{featuredBlogs[0].excerpt}</p>
                                        <Link className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition" to={`/blog/${featuredBlogs[0].id}`}>
                                            Read Post
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* Blog Card 2 */}
                            <div className="w-full md:w-1/2 px-4 mb-8 flex">
                                <div className="border border-coolGray-800 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow bg-coolGray-800 flex flex-col h-full">
                                    <Link className="block overflow-hidden" to={`/blog/${featuredBlogs[1].id}`}>
                                        <div className="bg-coolGray-700 p-4">
                                            <img className="w-full object-cover rounded-md" src={featuredBlogs[1].image} alt={featuredBlogs[1].title} />
                                        </div>
                                    </Link>
                                    <div className="p-4 flex-1 flex flex-col">
                                        <div className="mb-2">
                                            <span className="inline-block py-1 px-3 text-xs leading-5 text-green-400 hover:text-green-300 font-medium uppercase bg-green-900 bg-opacity-20 hover:bg-opacity-30 rounded-full shadow-sm">
                                                {featuredBlogs[1].category}
                                            </span>
                                        </div>
                                        <Link className="mb-2 text-lg md:text-xl leading-tight text-white hover:text-green-400 font-bold hover:underline" to={`/blog/${featuredBlogs[1].id}`}>
                                            {featuredBlogs[1].title}
                                        </Link>
                                        <p className="text-coolGray-300 mb-4 text-sm md:text-base font-medium flex-1">{featuredBlogs[1].excerpt}</p>
                                        <Link className="mt-auto inline-block w-full py-2 px-4 bg-green-500 text-white text-center rounded-md font-medium hover:bg-green-600 transition" to={`/blog/${featuredBlogs[1].id}`}>
                                            Read Post
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <hr className="border-t border-white opacity-40 my-0" />
            </>
        </React.Fragment>
    );
}

